// Lightweight scaffold for vendor-manager portal pages that are not built out yet.
// Matches the admin portal page styling (header + white card).
const PlaceholderPage = ({ title, description }) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center flex-wrap gap-3">
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
    </div>

    <div className="bg-white shadow rounded-lg p-12 text-center">
      <p className="text-sm text-gray-500">
        {description || `${title} — coming soon.`}
      </p>
    </div>
  </div>
);

export default PlaceholderPage;
